import { render, staticRenderFns } from "./AllowancesPlanNameTable.vue?vue&type=template&id=09ab7cc9&"
import script from "./AllowancesPlanNameTable.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanNameTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports